import { Component, Inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { ConfigStorage, ENVIRONMENT, Link, UserStorage } from '@scisys-uim/uim-common';


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent {

  displayedNotificationTypes = ["TransferAssetAction", "FirearmAssignmentAction"]
  bannerImageAssetPath: string;
  title: string;
  links: Link[];

  readyToShowReports: boolean = false;
  graphTitle: string;
  graphHTML: SafeHtml;

  private graphHTMLList: GraphObject[];
  private graphDisplayIndex: number;

  constructor(@Inject(ENVIRONMENT) private environment: any, public configService: ConfigStorage, private router: Router, private userStorage: UserStorage,
    protected snackbar: MatSnackBar, private sanitizer: DomSanitizer) {
    this.bannerImageAssetPath = this.environment?.bannerImageAssetPathDefault;
  }

  ngOnInit() {
    this.configService.resolve().subscribe(config => {
      this.title = config.title;
    });

    // this.userStorage.nextNonNullItem().subscribe(user => {
    //   if (user?.isAuthenticated()) {
    //     this.readyToShowReports = true;
    //   }
    // });

    this.links = [];
  }

}

class GraphObject {

  constructor(public graphTitle: string, public graphHTML: string) {

  }

}
